<!-- 入库验车 -->
<template>
  <div class="car-details">
    <QS-scroller-box>
      <p class="title">入库验车</p>
      <!-- 交接信息 -->
      <turnOverInfo ref="turnOverInfoRef" :stockInfo="stockInfo"/>
      <!-- 验车信息 -->
      <checkCarInfo
        ref="checkCarInfoRef"
        :photo="photo"
        :inspectionAttachment="inspectionAttachment"
        :inspectionVideo="inspectionVideo"
      />
      <template #bottomAction>
        <el-button @click="goPageBack" size="mini">取消</el-button>
        <el-button
          :loading="submitLoading"
          @click="submit"
          type="primary"
          size="mini"
        >提交</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { editOutIn, getOutInDetails, getTempOutInDetails, stockLogFindLastOne } from '@/api/domain/returnLease'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { formatDate } from '@/utils'
import { useViolationWarnAlert } from '@/utils/useWarnAlert.js'
import { mapState } from 'vuex'
import checkCarInfo from './components/checkCarInfo.vue'
import turnOverInfo from './components/turnOverInfo.vue'

export default {
  components: {
    checkCarInfo,
    turnOverInfo,
  },
  inject: ['orderData'],
  data() {
    return {
      submitLoading: false,
      inspectionAttachment: '',
      photo: '',
      inspectionVideo: '',
      carTubeList: [],
      stockInfo: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        remarks: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        outStockTime: '',
      },
      stockId: '', //
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    this.getCarTubeList()
    this.getStockId().then(() => {
      // 获取出入库详情
      this.getOutInDetails()
    })
  },
  methods: {
    // 新增出库记录
    async submit() {
      try {
        await this.$refs.turnOverInfoRef.validateParams()
      } catch {
        return
      }

      // 获取交接信息
      // eslint-disable-next-line no-shadow
      const turnOverInfo = this.$refs.turnOverInfoRef.stock
      // 获取验车信息
      // eslint-disable-next-line no-shadow
      const checkCarInfo = this.$refs.checkCarInfoRef.getCheckCarInfoData()
      this.submitLoading = true
      const data = {
        id: this.stockId,
        ...turnOverInfo,
        ...checkCarInfo,
      }

      try {
        const { code } = await editOutIn(data)
        if (code !== 1) return
        this.$message.success('提交成功')
        setTimeout(() => {
          this.$emit('checkoutCarCompleted')
          useViolationWarnAlert()
        }, 1200)
      } catch {
        // 接口错误由 request 拦截器提示，这里只负责关闭 loading。
      } finally {
        this.submitLoading = false
      }
    },
    // 返回上一级页面
    goPageBack() {
      this.$refreshBack(false) // 关闭当前tab
    },
    // 获取最新的出入库记录
    // 参数 {carId:车辆ID type：1出库 2入库, orderId：订单ID}
    getStockId() {
      return new Promise((resolve, reject) => {
        const { carId, id } = this.orderData
        stockLogFindLastOne({
          carId,
          type: 2,
          orderId: id,
          sourceType: 1,
          sourceId: id,
        }).then((res) => {
          const { code, data } = res
          if (code !== 1) {
            reject(data)
            return
          }
          this.stockId = data?.id
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code !== 1) return
      this.carTubeList = data
    },
    // 获取出入库详情
    async getOutInDetails() {
      const dataList = await Promise.allSettled([
        getTempOutInDetails({ id: this.stockId }),
        getOutInDetails({ id: this.stockId }),
      ])
      const { data, code } = dataList[1].value
      if (code !== 1) return
      // 获取出入库记录提交确认信息
      const tempData = dataList[0] && dataList[0].value.code === 1 && dataList[0].value.data
      const outInDetails = dataList[1]?.value?.data
      const { userInfo, carTubeList } = this
      // 获取当前登录用户id
      const { id } = userInfo
      let takeOverManager
      // 如果在交接车管列表中存在登录人信息id则展示当前登录人信息
      if (carTubeList.find((item) => item.id === id)) {
        takeOverManager = id
      }
      const { stockInfoVo } = data
      this.stockInfo.displayMile = stockInfoVo.displayMile ?? ''
      this.stockInfo.takeOverTime = stockInfoVo.takeOverTime || formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
      this.stockInfo.takeOverManager = stockInfoVo.takeOverManager || takeOverManager || ''
      this.stockInfo.remarks = stockInfoVo.remarks
      this.stockInfo.actualTakeOverName = stockInfoVo.actualTakeOverName || tempData.actualTakeOverName
      this.stockInfo.actualTakeOverTel = stockInfoVo.actualTakeOverTel || tempData.actualTakeOverTel
      this.stockInfo.remainingReserves = stockInfoVo.remainingReserves
      this.inspectionAttachment = stockInfoVo.inspectionAttachment
      this.photo = stockInfoVo.photo
      this.inspectionVideo = stockInfoVo.inspectionVideo || ''
      this.stockInfo.outStockTime = outInDetails?.rentOrderVO?.outStockTime || ''
    },
  },
}
</script>
<style scoped lang="scss">
.car-details {
  height: 100%;
}
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
</style>
